import { createSelector } from 'reselect';
import { shadeSelectors } from '../../shade';

const getInitialValues = shadeId => createSelector([shadeSelectors.getById], shadeById => shadeById[shadeId] || {});

export const makeGetInitialValues = createSelector(getInitialValues, initialValues => initialValues);
